/** Keys used with encryptedStorage. */
export const STORAGE_KEYS = {
  USER: 'user',
  VERIFY_OTP_RESPONSE: 'verifyOtpResponse',
  ENCRYPTION_USER_ID: 'encryptionUserId',
};

export default STORAGE_KEYS;
